import ConfirmationEmailBrick from './ConfirmationEmailBrick';
import { useDispatch, useSelector } from 'react-redux';
import FJAction from '../../action/FJAction';

const ConfirmEmailContainer = props => {
    const dispatch = useDispatch();
    // const [email, setEmail] = useState('') // 邮箱输入
    // default|register注册|login登录|confirmationEmail确认邮箱|verificationCode输入验证码|resetPassword重置密码
    let { popupType, stepChange } = props;
    const { confirmEmail } = useSelector(store => {
        return {
            confirmEmail: store.mainStore.confirmEmail,
            passwordSeeLogin: store.mainStore.passwordSeeLogin,
        };
    });
    // 账号确认(发送验证码)
    let _emailConfirm = (obj, callback) => {
        // setEmail(curEmail)
        dispatch(FJAction.sendCode(obj, callback));
    };
    // 邮件账号改变(发送验证码的邮箱号)
    let _confirmEmailChange = curConfirmEmail => {
        // setEmail(curEmail)
        dispatch(FJAction.changeConfirmEmail(curConfirmEmail));
    };

    return (
        <ConfirmationEmailBrick
            value={confirmEmail}
            confirmClick={_emailConfirm}
            onChange={_confirmEmailChange}
            stepChange={stepChange}
            popupType={popupType}
            active={true}
        />
    );
};

export default ConfirmEmailContainer;
